import { RootState } from "@/store/store";
import { accountsStateSelector } from "@/store/accounts/selectors/slice-data/accountsStateSelector";

export const firstExistingAccountSelector = (state: RootState) => {
  return accountsStateSelector(state)?.accounts?.at(0);
};
